import DOMPurify from "dompurify";
import "katex/dist/katex.min.css";
import { FC, useState } from "react";
import Latex from "react-latex-next";
import s from "./style.module.css";

type Props = {
  content: string;
  isArticleDetails?: boolean;
};

const AppLatex: FC<Props> = ({ content, isArticleDetails }) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const [isXsScreen, setIsXsScreen] = useState(window.innerWidth > 767 && window.innerWidth <= 1151);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
    setIsXsScreen(window.innerWidth > 767 && window.innerWidth <= 1151);
  };
  window.addEventListener('resize', handleResize);

  // Regular expression to match YouTube URLs
  // Regex for both long and short YouTube URLs
  const youtubeRegex = /(https?:\/\/(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)[a-zA-Z0-9_-]+(?:\?[^\s]*)?)/g;

  // Extract video ID from either format
  const videoIdMatch = content?.match(
    /(?:v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );

  // Split the message into parts - text and YouTube video link
  const messageParts = content?.split(youtubeRegex) || [];

  // Extract the video ID from the regex match
  const videoId = videoIdMatch ? videoIdMatch[1] : "";

  const cleanHtml = DOMPurify.sanitize(
    messageParts?.[0]?.replaceAll("amp;", "").replaceAll("<p><br></p>", "")
  );

  // Split by math delimiters ($...$)
  const parts = cleanHtml.split(/(\$[^$]+\$)/g);

  return (
    <div className={s.contentText}>
      {/* Display the text part first */}
      {parts.map((part, index) =>
        part.startsWith("$") ? (
          <Latex key={index}>{part}</Latex>
        ) : (
          <span
            key={index}
            dangerouslySetInnerHTML={{ __html: part }}
          />
        )
      )}

      {/* Display YouTube video if there is a match */}
      {videoId && (
        <div>
          <iframe
            width="95%"
            height={isMobile ? "200px" : isXsScreen ? "450px" : isArticleDetails ? "450px" : "250px"}
            style={{ borderRadius: "24px" }}
            src={`https://www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube video"
          ></iframe>
        </div>
      )}

      {/* Display any text after the video link */}
      {messageParts?.length > 1 && <p>
        <Latex>
          {messageParts[messageParts.length - 1] ? messageParts[messageParts.length - 1]?.replaceAll("amp;", "")?.replaceAll("<br />", "") : ""}
        </Latex>
      </p>}
    </div>
  );
};

export default AppLatex;
